var _defs, _path, _path2, _path3, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMm = function SvgMm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    transform: "scale(8.844)",
    fill: "#fff",
    d: "M0-.5l.162.5h-.324z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-144)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(144)",
    width: 18,
    height: 12
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0-.1h640V160H0z",
    fill: "#fecb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 320h640v160H0z",
    fill: "#ea2839"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 160h640v160H0z",
    fill: "#34b233"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 9,
    y: 6.422,
    width: 18,
    height: 12,
    transform: "matrix(40 0 0 40 -40 0)"
  })));
};
export default __webpack_public_path__ + "assets/bd85d8d6698b5e9847fd293e4aabf789.svg";
export { SvgMm as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/mm.svg